export const Free = {
    name: "Free",
    color: "#3DA8D1",
    bgColor:"#E4F8FF",
    textColor:"#3697bc",
    description: "No credit card required",
    cardDescription : "A simple way to get your application running in minutes.",
    isFree: true,
    inOffer: false,
    isDiscounted: false,
    price: {
        monthly: {
            stripePriceId: process.env.REACT_APP_STRIPE_FREE_MONTHLY_PRICE,
            amount: 0
        },
        annually: {
            stripePriceId: process.env.REACT_APP_STRIPE_FREE_ANNUAL_PRICE,
            amount: 0
        }
    },
    getDiscountedPrice: () => 0,
    includesOtherProductProperties: false,
    includedProductName: "",
    stripeProductId: process.env.REACT_APP_STRIPE_FREE_PRODUCT_ID,
    propertiesShownInCard: [
        "Up to 2 seats",
        "1 Apps",
        "2 Super App portals/app",
        "500 MB data size",
        "100 records",
        "3 Editable Roles",
    ]
};

export const Starter = {
    name: "Starter",
    color: "#6ECB71",
    bgColor:"#EAFFE5",
    textColor:"#63b665",
    description: "Free for a limited time",
    cardDescription:"Unlock essential tools and features for small businesses on the rise.",
    inOffer: true,
    isDiscounted: false,
    price: {
        monthly: {
            stripePriceId: process.env.REACT_APP_STRIPE_STARTER_MONTHLY_PRICE,
            amount: 30
        },
        annually: {
            stripePriceId: process.env.REACT_APP_STRIPE_STARTER_ANNUAL_PRICE,
            amount: 300
        }
    },
    getDiscountedPrice: () => 0,
    includesOtherProductProperties: true,
    includedProductName: "Free",
    stripeProductId: process.env.REACT_APP_STRIPE_STARTER_PRODUCT_ID,
    propertiesShownInCard: [
        "Up to 20 seats",
        "5 Apps",
        "3 Super App portals/app",
        "Calculated field",
        "Editable default Roles",
        "5 GB data size",
        "5,000 records",
    ],
};

export const Pro = {
    name: "Pro",
    color: "#E5624D",
    bgColor:"#FFE9E5",
    textColor:"#ce5845",
    description: "Per seat, billed annually",
    cardDescription:"Comprehensive solutions in ONE workspace for cross-functional teams.",
    inOffer: true,
    isDiscounted: false,
    price: {
        monthly: {
            stripePriceId: process.env.REACT_APP_STRIPE_PRO_MONTHLY_PRICE,
            amount: 48
        },
        annually: {
            stripePriceId: process.env.REACT_APP_STRIPE_PRO_ANNUAL_PRICE,
            amount: 480
        }
    },
    getDiscountedPrice: (price) => price / 2,
    includesOtherProductProperties: true,
    includedProductName: "Starter",
    stripeProductId: process.env.REACT_APP_STRIPE_PRO_PRODUCT_ID,
    propertiesShownInCard: [
        "Up to 100 seats ",
        "20 Apps",
        "5 Super App portals/app",
        "Fully configurable Roles",
        "200 GB data size",
        "Unlimited records",
        "Company logo",
        "Premium support",
    ],
};

export const Enterprise = {
    name: "Enterprise",
    color: "#6F5CD5",
    bgColor:"#E9E5FF",
    textColor:"#6352bf",
    description: "Per seat, billed annually",
    cardDescription:"Scalable and fully-customized app workspace for entire organization.",
    inOffer: true,
    isDiscounted: false,
    price: {
        monthly: {
            stripePriceId: process.env.REACT_APP_STRIPE_PRO_MONTHLY_PRICE,
            amount: 48
        },
        annually: {
            stripePriceId: process.env.REACT_APP_STRIPE_PRO_ANNUAL_PRICE,
            amount: 480
        }
    },
    getDiscountedPrice: (price) => price / 2,
    includesOtherProductProperties: true,
    includedProductName: "Pro",
    stripeProductId: process.env.REACT_APP_STRIPE_PRO_PRODUCT_ID,
    propertiesShownInCard: [
        "Unlimited seats",
        "Unlimited apps",
        "Unlimited Super App portals/app",
        "1,000 GB data size"
    ],
};

export const SUBSCRIPTION_PLANS = [
    Free, Starter, Pro, Enterprise
];

export const GridDetails = [
    {
        section: "Essentials",
        properties: [
            {
                property: "Max number of seats",
                Free: "2",
                Standard: "20",
                Pro:"100",
                Enterprise:"Unlimited",
                tooltip:"Maximum number of user seats per workspace."
            },
            {
                property: "Max number of apps",
                Free: "1",
                Standard: "5",
                Pro: "20",
                Enterprise:"Unlimited",
                tooltip:"Maximum number of apps per workspace."
            },
            {
                property: "Data storage",
                Free: "500MB",
                Standard: "5GB",
                Pro: "200GB",
                Enterprise:"1,000GB",
                tooltip:"Maximum combined size of files, images, and records allowed per workspace."
            },
            {
                property: "Number of records",
                Free: "100",
                Standard: "5,000",
                Pro: "Unlimited",
                Enterprise:"Unlimited",
                tooltip:"Maximum number of records per workspace."

            },
            {
                property: "Super App portals/app",
                Free: "2",
                Standard: "3",
                Pro: "5",
                Enterprise:"Unlimited",
                tooltip:"Super App aims to become the go-to app for teams, reducing the need for multiple apps to fulfill different requirements. Example: Your Sales, Marketing, and Human Resources teams can collaborate seamlessly through interconnected portals in one app. Designated portals for each team can simplify their work processes and increase productivity."
            },
            {
                property: "App size",
                Free: "Small",
                Standard: "Medium",
                Pro: "Large",
                Enterprise:"Unlimited",
                tooltip:"The bigger the app size, the more objects, properties, relations, lists, and charts you can have in your apps."
            },
        ],
    },
    {
        section: "Productivity",
        properties: [
            {
                property: "AI recommendation",
                Free: "Yes",
                Standard: "Yes",
                Pro:"Yes",
                Enterprise:"Yes",
                tooltip:"Build or customize apps effortlessly with Alice AI recommendation."
            },
            {
                property: "Desktop, Tablet, Mobile",
                Free: "Yes",
                Standard: "Yes",
                Pro: "Yes",
                Enterprise:"Yes",
                tooltip:"Codeless One apps are designed to be responsive on desktop, tablet, and mobile devices by default."
            },
            {
                property: "Dashboards",
                Free: "1",
                Standard: "10",
                Pro: "Unlimited",
                Enterprise:"Unlimited",
                tooltip:"Maximum number of dashboards per workspace."
            },
            {
                property: "Reports",
                Free: "1",
                Standard: "10",
                Pro: "Unlimited",
                Enterprise:"Unlimited",
                tooltip:"Maximum number of reports per workspace."

            },
            {
                property: "Notifications",
                Free: "Yes",
                Standard: "Yes",
                Pro: "Yes",
                Enterprise:"Yes",
                tooltip:"Automate email notifications based on customized conditions."
            },
            {
                property: "Calculated field",
                Free: "Yes",
                Standard: "Yes",
                Pro: "Yes",
                Enterprise:"Yes",
                tooltip:"Include calculated properties in your app using formulas, such as Revenue = Price * Quantity of goods."
            },
            {
                property: "User Role/Rights management",
                Free: "3 Editable Roles",
                Standard: "3 Editable Roles",
                Pro: "Fully Editable",
                Enterprise:"Fully Editable",
                tooltip:"Set up who can access what information in your apps."
                
            },
        ],
    },
    {
        section: "Views",
        properties: [
            {
                property: "Table",
                Free: "Yes",
                Standard: "Yes",
                Pro:"Yes",
                Enterprise:"Yes",
                tooltip:"Visualize your data in a customized Table view."
            },
            {
                property: "Split view",
                Free: "Yes",
                Standard: "Yes",
                Pro: "Yes",
                Enterprise:"Yes",
                tooltip:"Easily view detailed information for records without having to switch between pages."
            },
            {
                property: "Kanban",
                Free: "Yes",
                Standard: "Yes",
                Pro: "Yes",
                Enterprise:"Yes",
                tooltip:"Manage and organize work more productively using a Kanban view."
            },
            {
                property: "Cards",
                Free: "Yes",
                Standard: "Yes",
                Pro: "Yes",
                Enterprise:"Yes",
                tooltip:"Show each record, e.g. Contacts, Orders, and Employees in a Card view."
            },
            {
                property: "Calendar",
                Free: "Yes",
                Standard: "Yes",
                Pro: "Yes",
                Enterprise:"Yes",
                tooltip:"Display time-critical data in a calendar format to ensure you never miss a deadline."
            },
        ],
    },
    {
        section: "Add-ons",
        properties: [
            {
                property: "Additional Data Storage",
                Free: "",
                Standard: "",
                Pro:"Available for purchase",
                Enterprise:"Available for purchase",
                tooltip:"No need to worry about running out of data storage."
            },
        ],
    },
    {
        section: "Personalization and support", 
        properties: [
            {
                property: "Custom Org and App URL",
                Free: "Yes",
                Standard: "Yes",
                Pro:"Yes",
                Enterprise:"Yes",
                tooltip:"Customize the name and URL of your apps."
            },
            {
                property: "Logo",
                Free: "",
                Standard: "",
                Pro: "Yes",
                Enterprise:"Yes",
                tooltip:"Replace Codeless ONE logo with yours in the app and browser tab."
            },
            {
                property: "Customer support",
                Free: "Online",
                Standard: "Online",
                Pro: "Premier",
                Enterprise:"Premier",
                tooltip:"Get help from our support team anytime. "
            },
            {
                property: "Dedicated CS Manager",
                Free: "",
                Standard: "",
                Pro: "Yes",
                Enterprise:"Yes",
                tooltip:"Get personalized help, onboarding, and training support."
            },
        ],
    },
   
];